export const routes = {
    HOME: { path: '/' },
    EXPLORE: { path: '/explore' },
    MODULES: { path: '/' },
    MODULE: { path: '/module/:moduleId' },
    UNIT: { path: '/module/:moduleId/unit/:unitId' },
    FAVORITES: { path: '/favorites' },
    LOGIN: { path: '/login/' },
    FORGOT_PASSWORD: { path: '/login/forgot-password' },
    PASSWORD_RECOVERY: { path: '/login/recovery' },
    PASSWORD_RESET: { path: '/activate' },
    MY_ACCOUNT: { path: '/account' },
    CONTACTS: { path: '/contacts' },
    DSS: { path: '/decision-support' },
    DSS_FORM: { path: '/decision-support/:formId' },
    FAQS: { path: '/faqs' },
    PAGE_404: { path: '/404' },
    STYLEGUIDE: { path: '/styleguide' },
    TRANSLATIONS: { path: '/translations' },
    TYPEFORMS: { path: '/typeforms' },
    LEGAL: { path: '/legal' }
};
